import { config } from '@uhg-abyss/web/tools/config';

import { useCustomQuery } from '../useCustomQuery';
import GetReviewTemplate from './ReviewTemplate.graphql';

export const useHealthgradesReviewTemplate = (options) =>
  useCustomQuery(GetReviewTemplate, {
    ...options,
    url: config('GRAPHQL_API_URL'),
    accessor: 'healthgradesReviewTemplate',
  });
